import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { RecipientEntityModel } from '@core/models/recipient-entity/recipient-entity.model';
import { ImportReportModel } from '@core/models/administration/imports/import-report.model';
import { ReferentialItem } from '../models/shared/referential-item.model';
import { PagedResult } from '../models/paged-result.model';
import { PagingParametersModel } from '../models/shared/paging-parameters.model';
import { RecipientEntitySearchCriteriaModel } from '../models/recipient-entity/recipient-entity-search-criteria.model';


@Injectable({
  providedIn: 'root'
})
export class RecipientEntitiesService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'recipientEntities');
  }

  getRecipientEntities(): Observable<RecipientEntityModel[]> {
    return this.invokeGet<RecipientEntityModel[]>();
  }


  getRecipientEntitiesReferential(): Observable<ReferentialItem[]> {
    return this.invokeGet<ReferentialItem[]>("referential");
  }

  getPagedRecipientEntityReferential(recipientEntitySearchCriteriaModel: RecipientEntitySearchCriteriaModel, sort?: string, order?: string, page?: number, size?: number): Observable<PagedResult<ReferentialItem>> {
    const pagingParameters = new PagingParametersModel(sort, order, page + 1, size);
    const userGroups = this.invokeGet<PagedResult<ReferentialItem>>(`paged-referential`, recipientEntitySearchCriteriaModel, pagingParameters);
    return userGroups;
  }

  getRecipientEntityById(recipientEntityId: number): Observable<RecipientEntityModel> {
    return this.invokeGet<RecipientEntityModel>(`${recipientEntityId}`);
  }

  createRecipientEntity(recipientEntity: RecipientEntityModel): Observable<any> {
    return this.invokePost(recipientEntity);
  }

  updateRecipientEntity(recipientEntity: RecipientEntityModel): Observable<any> {
    return this.invokePut(recipientEntity, `${recipientEntity.Id}`);
  }

  deactivateRecipientEntity(recipientEntityId: number): Observable<any> {
    return this.invokePut(null, `${recipientEntityId}/deactivate`);
  }

  activateRecipientEntity(recipientEntityId: number): Observable<any> {
    return this.invokePut(null, `${recipientEntityId}/activate`);
  }

  importRecipientEntities(files: File[]): Observable<ImportReportModel[]> {
    return this.invokeUploadFiles(files, `import`);
  }

  getMatchingIgnoreKeywords(): Observable<string[]> {
    return this.invokeGet('keywords');
  }

  updateMatchingIgnoreKeywords(keywords: string[]): Observable<string[]> {
    return this.invokePut(keywords, 'keywords');
  }
}
